import { ICopyRequisicaoCompraUseCase } from "../../../presentation/useCases/create/copy_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CopyRequisicaoCompraUseCase
 */

export class CopyRequisicaoCompraUseCase implements ICopyRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async copyRequisicaoCompra(
    idRequisicaoCompra: number,
  ): Promise<void> {
    await this.repository.copyRequisicaoCompra(idRequisicaoCompra);
  }
}
